import { CurrencyPipe, DatePipe } from '@angular/common';
import { Column, GridRow } from '@shared';

export class ChangesetException {
  @Column({
    title: 'Restaurant #',
    field: 'restaurantNo',
    order: 1,
    width: 80,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  restaurantNo: string;

  @Column({
    title: 'Tier Name',
    field: 'tierName',
    order: 2,
    width: 100,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  tierName: string;

  @Column({
    title: 'Item Name',
    field: 'itemName',
    order: 3,
    width: 150,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string;

  @Column({
    title: 'Scheduled Date',
    field: 'scheduledDate',
    order: 4,
    width: 100,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd HH:mm'],
    filterable: true,
    filterType: 'date',
    type: 'date',
    sortable: true,
    visibleInQuickView: true,
  })
  scheduledDate: Date | null;

  @Column({
    title: 'Exception Message',
    field: 'exceptionMessage',
    order: 5,
    width: 200,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: false,
    visibleInQuickView: true,
    align: 'left',
  })
  exceptionMessage: string;

  @Column({
    title: 'Current Price',
    field: 'currentPrice',
    order: 6,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    pipeToken: CurrencyPipe,
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  currentPrice: number | null;

  @Column({
    title: 'New Price',
    field: 'newPrice',
    order: 7,
    width: 80,
    filterable: true,
    pipeToken: CurrencyPipe,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  newPrice: number | null;

  @Column({
    title: 'Current Availability',
    field: 'currentAvailability',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  currentAvailability: boolean | null;

  @Column({
    title: 'New Availability',
    field: 'newAvailability',
    order: 8.5,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newAvailability: boolean | null;

  @Column({
    title: 'Current App/Delivery Availability',
    field: 'deliveryAvailability3P',
    order: 9,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  deliveryAvailability3P: boolean = false;

  @Column({
    title: 'New App/Delivery Availability',
    field: 'newDeliveryAvailability3P',
    order: 9.5,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newDeliveryAvailability3P: boolean | null;

  @Column({
    title: 'Current Delivery Price',
    field: 'currentDeliveryPrice',
    order: 10,
    width: 80,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  currentDeliveryPrice: number | null;

  @Column({
    title: 'New Delivery Price',
    field: 'newDeliveryPrice',
    order: 11,
    width: 80,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  newDeliveryPrice: number | null;

  @Column({
    title: 'Component Name',
    field: 'componentName',
    order: 3.5,
    width: 150,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  componentName: string;

  type?: string;

  constructor(changesetException?: Partial<ChangesetException>) {
    this.restaurantNo = changesetException?.restaurantNo || '';
    this.tierName = changesetException?.tierName || '';
    this.itemName = changesetException?.itemName || '';
    this.scheduledDate = changesetException?.scheduledDate ?? null;
    this.exceptionMessage = changesetException?.exceptionMessage || '';
    this.currentPrice = changesetException?.currentPrice ?? null;
    this.newPrice = changesetException?.newPrice ?? null;
    this.currentAvailability = changesetException?.currentAvailability ?? null;
    this.newAvailability = changesetException?.newAvailability ?? null;
    this.newDeliveryAvailability3P =
      changesetException?.newDeliveryAvailability3P ?? null;
    this.currentDeliveryPrice =
      changesetException?.currentDeliveryPrice ?? null;
    this.newDeliveryPrice = changesetException?.newDeliveryPrice ?? null;
    this.componentName = changesetException?.componentName || '';
    this.type = changesetException?.type;
  }
}

export class GridRowChangesetException extends GridRow(ChangesetException) {}
